import { render, staticRenderFns } from "./page-intro-block.vue?vue&type=template&id=8a7e8dd6&"
import script from "./page-intro-block.vue?vue&type=script&lang=js&"
export * from "./page-intro-block.vue?vue&type=script&lang=js&"
import style0 from "./page-intro-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports